import {useEffect, useState} from "react";
import {
  Box,
  Button,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import CompanyElement from "../componenets/CompanyElement";
import {getCompanies} from "../services/CompanyService";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import AddCompany from "../componenets/AddCompany";

const Companies = () => {

  const [items, setItems] = useState([])
  const [searchQuery, setSearchQuery] = useState("");
  const [addCompanyState, setAddCompanyState] = useState(false);

  useEffect(() => {
    getCompanies().then(res => {
      setItems(res.data);
    }).catch(e => console.log(e));
  }, [addCompanyState]);

  const closeAddCompany = () => {
    setAddCompanyState(false);
  }

  const openAddCompany = () => {
    setAddCompanyState(true);
  }

  const filteredItems = items.filter(item =>
    item.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.industry?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
      <>
        <AddCompany open={addCompanyState} handleClose={closeAddCompany}/>

        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, mb: 3 }}>
          <Typography sx={{
            fontWeight: 700,
            fontSize: { md: "32px", xs: "24px" },
            lineHeight: { md: "40px", xs: "32px" }
          }} color="primary.main">
            Companies
          </Typography>

          <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={openAddCompany}
          >
            Add Company
          </Button>
        </Box>

        {/* Search Section */}
        <Paper sx={{ p: 2, mb: 3 }} elevation={1}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TextField
                size="small"
                placeholder="Search companies..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ minWidth: 300 }}
                InputProps={{
                  startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                  ),
                }}
            />
            <Typography variant="caption" color="text.secondary">
              {filteredItems.length} of {items.length} companies
            </Typography>
          </Box>
        </Paper>

        {/* Companies Table */}
        <Paper sx={{ p: 2 }} elevation={1}>
          <Table sx={{tableLayout: "fixed", width: "100%", "&.MuiTable-root" : {
              borderCollapse: "separate",
              borderSpacing: "0 8px",
            }}}>
            <TableHead>
              <TableRow sx={{ "& .MuiTableCell-root": { padding: "8px 12px", fontSize: "0.8rem", fontWeight: 600 } }}>
                <TableCell align={"left"} sx={{ width: "25%" }}>
                  Name
                </TableCell>
                <TableCell align={"left"} sx={{ width: "20%" }}>
                  Industry
                </TableCell>
                <TableCell align={"left"} sx={{ width: "40%" }}>
                  Info
                </TableCell>
                <TableCell align={"center"} sx={{ width: "15%" }}>
                  Created
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredItems.map(function(item, i){
                return <CompanyElement item={item} key={i} />;
              })}
            </TableBody>
          </Table>
        </Paper>
      </>
  )
};

export default Companies;
